import { UserOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Card, Col, Row, Space, Statistic, Typography } from "antd";
import { Album, CalendarCheck, FolderTree, Music } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import { getDash } from "../utils/api";
import { useAuth } from "../utils/store";

const Home = () => {
  const user = useAuth((state) => state.user);

  const { data: dash, isLoading: isLoading3 } = useQuery({
    queryKey: ["dashboard"],
    queryFn: () => getDash(),
  });

  const colors = ["#C70039", "#FF5733", "#FFC300", "#219C90"];
  console.log(dash);

  return (
    <>
      <Space
        direction="vertical"
        size="large"
        style={{ width: "100%", padding: 20 }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            style={{ fontSize: 20, fontWeight: 600, marginBottom: 10 }}
          >
            Dashboard
          </Typography>
          <Link to="/systemvalues">
            <Button type="primary">System Values</Button>
          </Link>
        </div>

        <Row gutter={[16, 16]}>
          {[
            {
              name: "Users",
              value: dash?.users,
              icon: <UserOutlined />,
              link: "/users",
            },

            {
              name: "Subscription",
              value: dash?.subscription,
              icon: <CalendarCheck />,
              link: "/subs",
            },

            {
              name: "Categories",
              value: dash?.categories,
              icon: <FolderTree size={16} />,
              link: "/categories",
            },
            {
              name: "Music",
              value: dash?.music,
              icon: <Music size={16} />,
              link: "/music",
            },
            {
              name: "Albums",
              value: dash?.albums,
              icon: <Album size={16} />,
              link: "/album",
            },
          ]?.map((item, index) => (
            <Col className="gutter-row" span={8} xs={20} sm={8} key={index}>
              <Link to={item.link}>
                <Card>
                  <Statistic
                    title={item.name}
                    value={item.value}
                    //title color

                    prefix={item.icon}
                  />
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Space>
    </>
  );
};

export default Home;
